import styled from 'styled-components';

export default styled.div`
  height: 720px;
  position: relative;

  .custom-tooltip {
    display: flex;
    flex-direction: column;

    .item {
      display: flex;
      padding: 6px 0px;

      h5 {
        margin-bottom: 0px;
        font-size: 12px;
        font-weight: 500;
        color: black;

        &.main {
          flex: 1;
        }
      }

      border-bottom: 1px solid #E1E1E1;

      &:last-of-type {
        border-bottom: 0px;
      }
    }
  }

  .left-cont {
    position: absolute;
    width: 240px;
    top: 20px;
    height: 680px;
    left: 40px;
    z-index: 500;
    gap: 8px;

    overflow-y: auto;
    display: flex;
    flex-direction: column;

    .cont {
      background: white;
      padding: 14px var(--size);
      border-radius: 4px;
      box-shadow: 0px 5px 11px -1px rgba(0, 0, 0, 0.18);

      h1 {
        font-size: 15px;
        font-weight: 600;
      }

      &.icon-cont {
        display: flex;
        padding: 8px var(--size);
        gap: 10px;

        label {
          margin-bottom: 0px;
        }

        .icon {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .label {
          flex: 1;

          label {
            color: var(--color-primary-70);
            font-size: 14px;
          }
        }

        .value {
          label {
            font-size: 14px;
            font-weight: 600;
          }
        }

      }

      &.info {
        .items {
          display: flex;
          flex-direction: column;
          gap: 12px;

          .tags {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .ant-tag {
              margin-right: 0px;
            }
          }

          label {
            font-size: 12px;
            font-weight: 500;
            color: #8C8C8C;
          }

          h5 {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 0px;
          }
        }
      }
    }
  } 

  .leaflet-popup {
    top: 5px !important;
    left: 5px !important;
    z-index: 1 !important;
  }

  .map {
    height: 720px;

    .leaflet-popup-close-button {
      display: none;
    }

    .custom-popover {
      min-width: 176px;
      max-width: 230px;
      display: flex;
      flex-direction: column;
      gap: var(--size);

      .items {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .item {
          label {
            color: #8C8C8C;
            font-size: 10px
            font-weight: 500;
            margin-bottom: 4px;
          }

          h5 {
            color: #595959;
            font-size: 12px
            font-weight: 500;
            margin-bottom: 0px;

            &.red {
              color: #C00000;
            }

            &.green {
              color: #52C41A;
            }
          }
        }
      }

      .header {
        h1 {
          font-size: 14px;
          font-weight: 600;
        }
        label {
          color: var(--color-primary-70);
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 0px;
        }
      }
    }

    .leaflet-popup-tip-container {
      display: none;
    }

    .leaflet-popup-content {
      min-width: 176px !important;
    }
  }
`;
